<template>
  <div class="order-modify">
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      label-width="120px"
      style="overflow: auto"
    >
      <el-button
        v-if="canEdit"
        type="primary"
        :disabled="saving"
        :style="isNew ? 'position: fixed; right: 100px; z-index: 999' : 'position: fixed; right: 10px; z-index: 999'"
        @click="submit"
      >提交<span v-if="saving">中...</span></el-button>
      <el-button
        v-if="canEdit && isNew"
        type="primary"
        :disabled="saving"
        style="position: fixed; right: 10px; z-index: 999"
        @click="temporary"
      >暂存<span v-if="saving">中...</span></el-button>

      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="客户信息" name="first">
          <el-scrollbar>
            <div style="width: 100%">
              <div>
                <el-col :span="8">
                  <el-form-item label="订单编号">
                    <el-input
                      :value="form.fBillNo"
                      disabled
                      style="width: 100%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="客户">
                    <el-select-table2
                      v-model="form.fCustomer"
                      url="BusinessManage/Customer/ChoiceCustomerEntry"
                      label-field="fCustomer"
                      search-key="name"
                      :columns="[
                        { prop: 'fName', label: '客户' },
                        { prop: 'fBillingName', label: '开票名称' },
                        { prop: 'fName_sh', label: '收货人' },
                        { prop: 'fPhone', label: '电话' },
                      ]"
                      panel-width="70%"
                      @change="fCustomerChange"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="开票名称" prop="fBillingName">
                    <el-input v-model="form.fBillingName" clearable @input="changeValue" />
                  </el-form-item>
                </el-col>
              </div>
              <div>
                <el-col :span="8">
                  <el-form-item label="收货人" prop="fName_sh">
                    <el-input v-model="form.fName_sh" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="电话" prop="fPhone">
                    <el-input v-model="form.fPhone" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="收货地址" prop="fAddress_sh">
                    <el-input v-model="form.fAddress_sh" />
                  </el-form-item>
                </el-col>
              </div>
              <div>
                <el-col :span="8">
                  <el-form-item label="经营许可号" prop="fBusinessNo">
                    <el-input v-model="form.fBusinessNo" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="经营地址" prop="fAddress_jy">
                    <el-input v-model="form.fAddress_jy" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="区域" prop="fRegionID">
                    <el-select-ex
                      v-model="form.fRegionID"
                      url="BasicInformation/Region/RegionEntry"
                      label-field="fName"
                      style="width: 100%"
                      value-field="fRegionID"
                      @change="fRegionChange"
                    />
                  </el-form-item>
                </el-col>
              </div>
              <div>
                <el-col :span="8">
                  <el-form-item label="运费付款方式" prop="fPayType">
                    <el-select-ex
                      v-model="form.fPayType"
                      url="BasicInformation/PayType/PayTypeEntry"
                      value-field="fName"
                      label-field="fName"
                      style="width: 100%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="仓库" prop="fStockID">
                    <el-select-ex
                      v-model="form.fStockID"
                      label-field="fName"
                      value-field="fStockID"
                      :sel-first="isNew"
                      :change-confirm="stockChangeConfirm"
                      url="Warehouse/Stock/StockEntry"
                      style="width: 100%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="发货方式" prop="fDeliverType">
                    <el-select-ex
                      v-model="form.fDeliverType"
                      url="BasicInformation/DeliverType/DeliverTypeEntry"
                      value-field="fName"
                      label-field="fName"
                      style="width: 100%"
                    />
                  </el-form-item>
                </el-col>
              </div>
              <div style="width: 100%">
                <el-col :span="8">
                  <el-form-item label="交货日期" prop="fDate">
                    <el-date-picker
                      v-model="form.fDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :clearable="false"
                      style="width: 100%"
                    />
                  </el-form-item>
                </el-col>
              </div>
              <div>
                <el-col :span="8">
                  <el-form-item label="付款比例(%)" prop="fDeductionRatio">
                    <el-input-currency
                      v-model="form.fDeductionRatio"
                      :scale="2"
                      min="0"
                      max="100"
                      style="width:150px;"
                    />
                  </el-form-item>
                </el-col>
              </div>
              <div>
                <el-col :span="8">
                  <el-form-item label="备注">
                    <el-input v-model="form.fDes" type="textarea" :rows="4" />
                  </el-form-item>
                </el-col>
              </div>
            </div>
          </el-scrollbar>
        </el-tab-pane>
        <el-tab-pane label="订单信息" name="second">
          <el-scrollbar>
            <div style="display: flex; justify-content: space-between">
              <div style="display: flex; justify-content: space-between">
                <div>
                  <el-form-item v-if="tmp.type == 1" label="购买产品">
                    <el-select-table
                      v-model="tmp.proId"
                      :label.sync="tmp.proName"
                      url="ICItemManage/ICItem/ChoiceICItemEntry"
                      label-field="fName"
                      value-field="ficItemID"
                      :clearable="false"
                      :extra-param="{ prohibit: true,stockID: form.fStockID }"
                      :columns="[
                        { prop: 'fNumber', label: '编码' },
                        { prop: 'fName', label: '名称' },
                        { prop: 'fModel', label: '规格' },
                        { prop: 'fUnit', label: '单位' },
                      ]"
                      panel-width="500px"
                      @change="proChange1"
                    />
                  </el-form-item>
                  <el-form-item v-if="tmp.type == 2" label="购买组合">
                    <el-select-table
                      v-model="tmp.proId"
                      :label.sync="tmp.proName"
                      url="ICItemManage/ICItemZh/ChoiceICItemZhEntry"
                      label-field="fName"
                      value-field="fid"
                      :extra-param="{ prohibit: true }"
                      @change="proChange2"
                    />
                  </el-form-item>

                  <el-form-item v-if="tmp.type == 3" label="购买产品">

                    <el-select-table
                      v-model="tmp.proId"
                      :label.sync="tmp.proName"
                      url="ICItemManage/ItemFa/ChoiceItemFaEntry"
                      label-field="fName"
                      value-field="fid"
                      :search-params="{ prohibit: true,stockID: form.fStockID }"
                      @change="proChange3"
                    />

                  </el-form-item>

                  <!-- <el-form-item label=" ">
                  <el-input v-model="fullName" />
                </el-form-item> -->
                  <el-form-item label="购买数量">
                    <el-input-currency v-model="tmp.number" :scale="0" min="0" />
                  </el-form-item>

                  <el-form-item label=" ">
                    <el-button @click="addRow">添加</el-button>
                  </el-form-item>
                </div>
                <div style="margin:10px 0 0 10px">{{ fullName }}</div>

              </div>
              <div style="backgrond: yellow">
                <img :src="tmp.imgUrl" style="max-width: 300px">
              </div>
            </div>
            <el-table :data="form.entrys">
              <el-table-column width="30">
                <template slot-scope="scope">
                  <div class="tools">
                    <el-popconfirm
                      title="是否删除？"
                      @confirm="delRow(scope.$index)"
                    >
                      <i
                        slot="reference"
                        class="el-icon-remove-outline"
                        title="删除"
                      />
                    </el-popconfirm>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="产品编号" prop="fNumber" width="120px" />
              <el-table-column label="产品名称" prop="fName" />
              <el-table-column label="规格" prop="fModel" />
              <el-table-column label="单位" prop="fUnit" width="50px" />
              <el-table-column
                label="数量"
                label-class-name="font-color-red"
                width="100px"
              >
                <template slot-scope="scope">
                  <el-input-currency
                    v-model="scope.row.fQty"
                    :scale="0"
                    min="0"
                  />
                </template>
              </el-table-column>
              <el-table-column label="备注">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.fDes" />
                </template>
              </el-table-column>
            </el-table>
          </el-scrollbar>
        </el-tab-pane>
        <el-tab-pane v-if="!isNew" label="单据流程" name="third">
          <el-scrollbar>
            <el-table :data="form.procedureMessage" height="100%">
              <el-table-column label="流程步骤" prop="fName" />
              <el-table-column label="处理人" prop="fUserName" />
              <el-table-column label="状态" prop="fState" />
              <el-table-column
                label="日期"
                prop="fDate"
                :formatter="dateFormat"
              />
              <el-table-column label="意见" prop="fOpinion" />
            </el-table>
          </el-scrollbar>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'
import moment from 'moment'
export default {
  inject: ['getMap'],
  data: function() {
    return {
      form: {
        fCustomer: null,
        fBillingName: null,
        fName_sh: null,
        fPhone: null,
        fAddress_sh: null,
        fDeductionRatio: 100,
        fRegionID: null,
        fRegion: null,
        fBusinessNo: null,
        fAddress_jy: null,
        entrys: []
      },
      tmp: {
        type: 1,
        proId: null,
        proName: null,
        number: 0
      },
      fullName: null,
      rules: {
        fBillingName: [
          { required: true, message: '必填项', trigger: 'change' }
        ],
        fName_sh: [{ required: true, message: '必填项', trigger: 'change' }],
        fPhone: [{ required: true, message: '必填项', trigger: 'change' }],
        fAddress_sh: [{ required: true, message: '必填项', trigger: 'change' }],
        fPayType: [{ required: true, message: '必填项', trigger: 'change' }],
        fDeliverType: [
          { required: true, message: '必填项', trigger: 'change' }
        ],
        fStockID: [{ required: true, message: '必填项', trigger: 'change' }],
        fDate: [{ required: true, message: '必填项', trigger: 'change' }],
        fDeductionRatio: [{ required: true, message: '必填项', trigger: 'change' }],
        fCustomer: [{ required: true, message: '必填项', trigger: 'change' }],
        fRegionID: [{ required: true, message: '必填项', trigger: 'change' }],
        fBusinessNo: [{ required: true, message: '必填项', trigger: 'change' }],
        fAddress_jy: [{ required: true, message: '必填项', trigger: 'change' }]
      },

      activeName: 'first',

      loading: false,
      saving: false,
      isNew: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath
        vm.refresh()
      }
    })
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
    const vm = this
    vm.routePath = to.fullPath
    vm.refresh()
  },
  computed: {
    canEdit: function() {
      const userGrants = this.$store.state.userInfo.userGrants
      return userGrants.some((x) => x.key == '007001003')
    }
  },
  methods: {
    stockChangeConfirm: async function() {
      var success = await this.confirm('改变仓库需要重新录入产品明细')
      if (success) {
        this.form.entrys = []
        this.typeChange()
      }
      return success
    },

    fCustomerChange: function(item) {
      // console.log(item, 'item')
      this.form.fCustomer = item ? item.fName : null
      this.form.fBillingName = item ? item.fBillingName : null
      this.form.fName_sh = item ? item.fName_sh : null
      this.form.fPhone = item ? item.fPhone : null
      this.form.fAddress_sh = item ? item.fAddress_sh : null
      this.form.fRegionID = item ? item.fRegionID : null
      this.form.fRegion = item ? item.fRegion : null
      this.form.fBusinessNo = item ? item.fBusinessNo : null
      this.form.fAddress_jy = item ? item.fAddress_jy : null
    },
    fRegionChange: function(item) {
      this.form.fRegion = item ? item.fName : null
    },
    changeValue(item) {
      // console.log(item, 'changeValue')
    },
    typeChange: function() {
      this.tmp.proId = null
      this.tmp.proName = null
      this.tmp.pro = null
      this.tmp.imgUrl = null
      this.fullName = null
    },
    proChange1: function(item) {
      this.tmp.pro = item
      this.tmp.imgUrl = item ? item.pictureUrl : null
      this.fullName = item.fFullName
    },
    proChange2: function(item) {
      this.tmp.pro = null
      this.tmp.imgUrl = null
    },
    proChange3: function(item) {
      this.tmp.pro = null
      this.tmp.imgUrl = null
    },
    addRow: async function() {
      const type = this.tmp.type
      const typeName = type == 1 ? '产品' : type == 2 ? '组合' : '解决方案'
      if (!this.tmp.proId) {
        this.$message.error(`必须选择${typeName}`)
        return
      }

      const number = this.tmp.number
      if (number < 1) {
        this.$message.error('数量必须大于0')
        return
      }

      const fid = this.tmp.proId
      var res = []
      if (type == 1) {
        res = [this.tmp.pro]
      } else if (type == 2) {
        res = await this.$httpPost(
          'ICItemManage/ICItemZh/ICItemZhForGoodsEntry',
          { fid: fid }
        ).then((res) => res.datalist)
      } else if (type == 3) {
        res = await this.$httpPost('ICItemManage/ItemFa/ItemFaForGoodsEntry', {
          fid: fid
        }).then((res) => res.datalist)
      }

      this.entrysMerge(
        res.map((x) => ({
          ficItemID: x.ficItemID,
          fNumber: x.fNumber,
          fName: x.fName,
          fModel: x.fModel,
          fUnit: x.fUnit,
          fQty: x.fQty === undefined ? 1 : x.fQty
        })),
        number
      )
      this.fullName = null
      this.typeChange()
    },
    entrysMerge: function(items, number) {
      if (!items.length) return

      const entrys = this.form.entrys

      for (let i = 0; i < entrys.length; i++) {
        const entry = entrys[i]
        for (let j = 0; j < items.length; j++) {
          const item = items[j]
          if (entry.ficItemID == item.ficItemID) {
            entry.fQty += item.fQty * number
            break
          }
        }
      }

      for (let j = 0; j < items.length; j++) {
        var found = false
        const item = items[j]
        for (let i = 0; i < entrys.length; i++) {
          const entry = entrys[i]
          if (entry.ficItemID == item.ficItemID) {
            found = true
            break
          }
        }
        if (!found) {
          entrys.push({
            ficItemID: item.ficItemID,
            fNumber: item.fNumber,
            fName: item.fName,
            fModel: item.fModel,
            fUnit: item.fUnit,
            fQty: item.fQty * number,
            fDes: null
          })
        }
      }
    },
    delRow: function(index) {
      // console.log(index, "index");
      const entrys = this.form.entrys
      entrys.splice(index, 1)
    },

    submit: function() {
      this.$refs.form.validate(async(valid) => {
        if (valid) {
          const flg = await this.confirm('是否提交?')
          if (!flg) return

          this.saving = true
          this.$httpPost('OrderManage/Order/OrderModify', {
            datalist: JSON.stringify({
              modifyType: this.isNew ? 0 : 1,
              info: this.form
            })
          })
            .then((res) => {
              if (!res.isSuccess) {
                this.$message.error(res.message)
                return
              }

              // 重新刷新页面数据
              this.$message.success(res.message)
              // if (res.datalist) this.refresh(res.datalist)

              if (this.$route.query.ishome) {
                const tabName = this.$store.state.tabName
                this.getMap(tabName)
                this.$router.push({ path: '/' })
              } else {
                const tabName = this.$store.state.tabName
                this.getMap(tabName)
                this.$router.push({ path: '/orderManage/order' })
              }
            })
            .finally(() => (this.saving = false))
        } else {
          this.activeName = 'first'
          return false
        }
      })
    },
    temporary() {
      this.$refs.form.validate(async(valid) => {
        if (valid) {
          const flg = await this.confirm('是否提交?')
          if (!flg) return

          this.saving = true
          this.$httpPost('OrderManage/Order/OrderForTemporary', {
            datalist: JSON.stringify({
              modifyType: this.isNew ? 0 : 1,
              info: this.form
            })
          })
            .then((res) => {
              if (!res.isSuccess) {
                this.$message.error(res.message)
                return
              }

              // 重新刷新页面数据
              this.$message.success(res.message)
              // if (res.datalist) this.refresh(res.datalist)

              if (this.$route.query.ishome) {
                const tabName = this.$store.state.tabName
                this.getMap(tabName)
                this.$router.push({ path: '/' })
              } else {
                const tabName = this.$store.state.tabName
                this.getMap(tabName)
                this.$router.push({ path: '/orderManage/order' })
              }
            })
            .finally(() => (this.saving = false))
        } else {
          this.activeName = 'first'
          return false
        }
      })
    },
    refresh: async function(fid) {
      const id = fid || +this.$route.params.id
      this.isNew = !id
      if (id == 0) {
        return
      }

      this.loading = true
      const res = await this.$httpPost('OrderManage/Order/GetOrder', {
        fid: id
      }).finally(() => (this.loading = false))

      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }

      this.form = res.datalist
    },

    confirm: function(msg) {
      return this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => true)
        .catch(() => false)
    },
    //    日期格式转换
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style lang="less" scoped>
.order-modify {
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .tools i {
    margin-right: 5px;
    cursor: pointer;
    color: #409eff;
    font-size: 18px;
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #000;
    cursor: not-allowed;
  }
  .el-tabs {
    .el-tabs__content {
      height: calc(100vh - 150px);
      .el-tab-pane {
        height: calc(100vh - 150px);
      }
    }
  }
}
</style>
